export default "__VITE_ASSET__Dl_XMSrc__"